import React, {Component} from "react";
import {withRouter} from "react-router-dom";
import PageBack from "../components/buttons/page-back";
import {connect} from "react-redux";
import ChannelItem from "../components/elements/channel.item";
import {api, apis, msg, rd, sendGet, throws} from "../../vars/rd";
import {preloaderHide, preloaderShow} from "../../libs/redux/actions/preloader";
import DaoChannel from "../../modules/dao/channel";
import CategoryGenre from "../components/buttons/category.genre";
import _ from "underscore";

class SearchGenre extends Component {
    is_loading = false;

    scrollPosition = 0;
    scrollHandler;
    scrollRef;
    constructor(props) {
        super(props);

        this.scrollHandler = this.eventScroll.bind(this);

        const data = props.match.params.id;
        if(!data) props.history.goBack();

        this.state = {
            data,
            channels: [],
            page: 0,
            page_count: 0,
            total: 0
        }
    }

    /**
     * 페이지 마운트
     */
    componentDidMount() {
        this.mounted = true;

        this.filterChange(this.state.data);

        if(this.scrollRef) this.scrollRef.addEventListener("scroll", this.scrollHandler);
    }

    /**
     * 페이지 언마운트
     */
    componentWillUnmount() {
        this.mounted = false;

        if(this.scrollRef) this.scrollRef.removeEventListener("scroll", this.scrollHandler);
        this.scrollRef = null;
    }

    get dispatch() {
        return this.props.hasOwnProperty("dispatch") ? this.props.dispatch : () => {};
    }

    /**
     * 스크롤 이벤트
     * @param e
     */
    eventScroll(e) {
        try {
            const scroller = e.currentTarget;
            if(scroller) {
                const scrollHeight = scroller.scrollHeight;
                const height = scroller.offsetHeight;
                const top = scroller.scrollTop;
                if(top > this.scrollPosition) {
                    const gap = scrollHeight - (height + top);
                    if(gap < 30) this.channelNext();
                }
                this.scrollPosition = top;
            }
        } catch (e) {}
    }

    /**
     * 카테고리 변경
     * @param business {DaoCategory}
     */
    categoryChange(business) {
        if(business) this.filterChange(business.proid);
    }

    /**
     * @param data {string}
     */
    filterChange(data) {

        this.setState(
            { data, channels: [], page: 0, page_count: 0, total: 0 },
            async () => {
                await this.channelData(data, 1)
            }
        );
    }
    /**
     * 채널데이터 다음 페이지 존재여부
     * @returns {boolean}
     */
    get channelHasNext() {
        return this.state && ((this.state.total || 0) > (this.state.page_count || 0));
    }

    /**
     * 채널데이터 다음 인출
     * @returns
     */
    channelNext() {
        if (this.channelHasNext && !this.is_loading) {
            this.is_loading = true;
            const page = this.state.page + 1;
            this.channelData(this.state.data, page).then();
        }
    }

    /**
     * 채널데이터 인출
     * @param data {string}
     * @param page {number}
     * @returns {Promise<void>}
     */
    async channelData(data, page) {
        try {
            if(this.state.page !== page) {
                this.dispatch(preloaderShow());
                const url = api(apis.channel_search, {
                    serviceid: rd.user.serviceid,
                    groupid: rd.user.groupid,
                    search_key: 'genre',
                    search_val: data,
                    p: page,
                });
                sendGet(url)
                    .then(json => {
                        if(!json || json.result !== "OK") throws(msg().api_fail);
                        if(json.status === "OK") {
                            if(this.mounted) {
                                const page_count = json.page_count;
                                const total = json.total;
                                const channels = [];
                                if (json.hasOwnProperty('items') && json.items.length) {
                                    for (let i = 0; i < json.items.length; i++) {
                                        channels.push(new DaoChannel(json.items[i]));
                                    }
                                }
                                this.setState(
                                    {channels: [...this.state.channels, ...channels], page, page_count, total},
                                    () => {
                                        this.is_loading = false;
                                    }
                                );
                            }
                        }
                    })
                    .finally(() => {
                        this.dispatch(preloaderHide());
                    });
            }
        } catch (e) {}
    }

    render() {
        return (
            <div className="search-wrap mobile-search">
                <div className="search-box3">
                    <h2>
                        <PageBack />
                        장르별 채널
                    </h2>
                    <div className="search-bar2">
                        <div className="genre">
                            <ul className="list">
                                {
                                    rd.category.genre.length > 0 ?
                                        _.sortBy(rd.category.genre, 'proname').map((genre, i) => {
                                            genre.selected = (Number(this.state.data) === genre.proid);
                                            return <CategoryGenre type="menu" category={genre} key={i}
                                                                  onChange={this.categoryChange.bind(this)}/>;
                                        }) :
                                        null
                                }
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="search-result search-result3" ref={el => {
                    this.scrollRef = el;
                }}>
                    {
                        this.state.channels.length > 0 ?
                            this.state.channels.map((channel, i) => {
                                return (
                                    <ChannelItem data={channel} key={i} placeholder={'aaa'}/>
                                )
                            }) :
                            <div className={'empty'}>검색된 채널이 없습니다.</div>
                    }
                </div>
            </div>
        );
    }
}

export default connect()(withRouter(SearchGenre));


// WEBPACK FOOTER //
// ./src/pages/search/genre.jsx